module.exports = ".center{\r\n    text-align: center\r\n}\r\n.bold{\r\n    font-family: abb-bold\r\n}"